module.exports = __webpack_public_path__ + "static/media/30.be50880f.mp3";